import type { Locales } from '$i18n/i18n-types';
import { format, formatDistanceToNowStrict } from 'date-fns';
import ko from 'date-fns/locale/ko/index';

export const dateLocales: Record<Locales, Locale> = {
  ko,
  // en: enUS,
  // ja,
  // fr,
};

export const getHumanTimeDistanceToNowStrict = (date: Date | number, locale: Locales) => {
  return formatDistanceToNowStrict(date, {
    locale: dateLocales[locale],
    addSuffix: true,
  });
};

// 0이 일요일
export function getDayName(day: number, locale: Locales) {
  return format(new Date(Date.UTC(1970, 0, day + 4)), 'EEEE', { locale: dateLocales[locale] });
}

export function formatDate(date: Date | number, formatString: string, locale: Locales) {
  return format(date, formatString, { locale: dateLocales[locale] });
}
